import { IconArrowRight } from '@tabler/icons-react';
import { Link } from 'react-router-dom';

const BackButton = ({
  link,
  className,
}: {
  link: string;
  className?: string;
}) => {
  return (
    <Link to={link} className={`btn btn-dark w-[150px] h-[45px] ${className}`}>
      <IconArrowRight className="ps-3 size-7 rotate-180" /> Back To List
    </Link>
  );
};

export default BackButton;
